import firebase from 'firebase/app';

// import 'firebase/i
import 'firebase/auth'; // for authentication
import 'firebase/firestore'; // for cloud firestore
import 'firebase/storage'; // for storage

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCUbncnCCjXh9ucqROKfa0nNLUVXiIDc0c',
  authDomain: 'lofizival.firebaseapp.com',
  projectId: 'lofizival',
  storageBucket: 'lofizival.appspot.com',
  messagingSenderId: '1017227344935',
  appId: '1:1017227344935:web:20454e19e31111ec74e202',
  measurementId: 'G-SN6YXH0CE3',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebaseApp.storage();

export { auth, provider, storage };
export default db;
